import { useEffect, useMemo, useState } from "react";
import { getAuthFromCookie } from "../auth/auth";

interface WelcomeScreenProps {
  onGetStarted: () => void;
  onExplore: () => void;
}

const metrics = [
  { label: "Total Spend", value: "$48.2M", sub: "Across 12 categories" },
  { label: "Compliance", value: "91%", sub: "Contract adherence" },
  { label: "Savings Potential", value: "20.2%", sub: "AI-identified opportunities" },
];

function getGreetingByHour(hour: number): string {
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
}

export function WelcomeScreen({ onGetStarted, onExplore }: WelcomeScreenProps) {
  const [hour, setHour] = useState<number>(new Date().getHours());
  const user = useMemo(() => getAuthFromCookie(), []);

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setHour(new Date().getHours());
    }, 60_000);

    return () => {
      window.clearInterval(intervalId);
    };
  }, []);

  const userName =
    [user?.firstname, user?.lastname].filter(Boolean).join(" ").trim() ||
    user?.email?.split("@")[0] ||
    "User";

  const greeting = `${getGreetingByHour(hour)}, ${userName}`;

  return (
    <div className="welcome-screen">
      <div className="welcome-layout">
        <section className="welcome-main">
          <div className="welcome-copy card-animate-in delay-0">
            <p className="welcome-greeting">{greeting}</p>
            <h1 className="welcome-title">Welcome to ProcurAI</h1>
            <p className="welcome-subtitle">
              Turn procurement data into savings, smartest sourcing decisions, and supplier intelligence.
            </p>
          </div>

          <div className="welcome-actions card-animate-in delay-150">
            <button type="button" onClick={onGetStarted} className="welcome-btn-primary">
              <span>Get Started</span>
              <span aria-hidden>→</span>
            </button>
            <button type="button" onClick={onExplore} className="welcome-btn-link">
              Explore with sample data
            </button>
          </div>
        </section>

        <aside className="welcome-metrics">
          {metrics.map(({ label, value, sub }, index) => (
            <article
              key={label}
              className={`welcome-metric-card card-animate-in delay-${200 + index * 100}`}
            >
              <p className="welcome-metric-label">{label}</p>
              <p className="welcome-metric-value">{value}</p>
              <p className="welcome-metric-sub">{sub}</p>
            </article>
          ))}
        </aside>
      </div>
    </div>
  );
}
